import { render, staticRenderFns } from "./FeaturedHeroTournament.vue?vue&type=template&id=25413a41&scoped=true&"
import script from "./FeaturedHeroTournament.vue?vue&type=script&lang=js&"
export * from "./FeaturedHeroTournament.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedHeroTournament.vue?vue&type=style&index=0&id=25413a41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25413a41",
  null
  
)

export default component.exports